import React, { useEffect, useState } from 'react'
import '../AdminDashboardAdvertisers.css';
import { getAdvertiserData } from '../../../../services/getAdvertiserData';
import { deleteAdvertiser } from '../../../../services/advertiserAPI';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { getToken } from '../../../../features/token/tokenSaver';
export default function AdvertisersHome(props) {
    const navigate = useNavigate();
    const [advertisers, setAdvertisers] = useState([]);
    const [deletingAdvertiserId, setDeletingAdvertiserId] = useState(null);
    const token = useSelector(getToken)
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    const formatPhone = (phone) => {
        const value = String(phone || '').trim();
        return value || '—';
    };

    const loadAdvertisers = () => {
        getAdvertiserData(token).then(response => {
            setAdvertisers(response.data.advertisers)
        }).catch(e => {
            console.log(e.data)
        })
    };

    useEffect(() => {
        loadAdvertisers();
        return () => {

        }
    }, [])

    const handleDeleteAdvertiser = async (e, advertiser) => {
        e.stopPropagation();
        if (!advertiser?.AdvertiserId) {
            return;
        }
        const confirmed = window.confirm(
            `Delete advertiser #${advertiser.AdvertiserId} (${advertiser.CompanyName || 'Unknown'})? This also deletes their campaigns and payment records.`
        );
        if (!confirmed) {
            return;
        }

        try {
            setDeletingAdvertiserId(advertiser.AdvertiserId);
            await deleteAdvertiser(advertiser.AdvertiserId, token);
            setAdvertisers((prev) => prev.filter((a) => a.AdvertiserId !== advertiser.AdvertiserId));
        } catch (err) {
            const message = err?.response?.data?.error || err?.message || 'Failed to delete advertiser';
            window.alert(message);
            loadAdvertisers();
        } finally {
            setDeletingAdvertiserId(null);
        }
    };

    return (

            <div >
                <span className='registeredScreensTitle advertiserListTitle'>Advertiser Accounts</span>
            <input type={"submit"} value={"+"} className='addAdvertiser' onClick={() => { navigate("/adminDashboard/advertisers/create") }} />

                <div className='adminDashboardScreensTableContainer'>
                    {advertisers.length > 0 && <table className='adminDashboardScreensTable'>
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Company Name</th>
                                <th>Primary Contact</th>
                                <th>Phone</th>
                                <th>Slot Cost</th>
                                <th>Active</th>
                                <th>Activated</th>
                                <th>Edit</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {advertisers.map(advertiser => (
                                <tr key={advertiser.AdvertiserId} onClick={() => { navigate('/adminDashboard/advertisers/details/' + advertiser.AdvertiserId) }}>
                                    <td>{advertiser.AdvertiserId}</td>
                                    <td>{advertiser.CompanyName}</td>
                                    <td>{`${advertiser.Fname || ''} ${advertiser.Lname || ''}`.trim() || 'N/A'}</td>
                                    <td>{formatPhone(advertiser.PhoneNumber)}</td>
                                    <td>{advertiser.SlotCost !== undefined && advertiser.SlotCost !== null ? currencyFormatter.format(advertiser.SlotCost) : 'N/A'}</td>
                                    <td><span className={advertiser.Active === true && 'activeStatus' || 'inactiveStatus'}>{advertiser.Active === true && 'Active' || 'Inactive'}</span></td>
                                    <td>
                                        <span className={advertiser.AccountActivated ? 'activeStatus' : 'inactiveStatus'}>
                                            {advertiser.AccountActivated ? 'Yes' : 'No'}
                                        </span>
                                    </td>
                                    <td>
                                        <button 
                                            onClick={(e) => { 
                                                e.stopPropagation();
                                                navigate(`/adminDashboard/advertisers/details/${advertiser.AdvertiserId}?tab=edit`)
                                            }}
                                            className='advertiserEditActionBtn'
                                        >
                                            Edit
                                        </button>
                                    </td>
                                    <td>
                                        <button
                                            onClick={(e) => handleDeleteAdvertiser(e, advertiser)}
                                            className='advertiserDeleteActionBtn'
                                            disabled={deletingAdvertiserId === advertiser.AdvertiserId}
                                        >
                                            {deletingAdvertiserId === advertiser.AdvertiserId ? 'Deleting...' : 'Delete'}
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>}
                    {advertisers.length === 0 && <div className='adminEmptyState'>No advertisers found.</div>}
                </div>
            </div>
    )
}
